import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Error from "../../components/404/404";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

const ErrorPage = () => {
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={"404"} pagesub={"404"} />
      <Error />
      <Footer ftClass={"s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default ErrorPage;
